import { lazy } from 'react';

// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';

// login routing
const AuthLogin = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
const AuthRegister = Loadable(lazy(() => import('views/pages/authentication/authentication3/Register3')));
const AuthForgotPassword = Loadable(lazy(() => import('views/pages/authentication/authentication3/ForgotPassword3')));
const LoginCongnitoCallback = Loadable(lazy(() => import('views/pages/authentication/AwsCognitoLoginCallback')));
const AutomationTestLogin = Loadable(lazy(() => import('views/pages/authentication/authentication3/AutomationTestLogin')));
const PagesLanding = Loadable(lazy(() => import('views/pages/landing')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
    path: '/',
    element: (
        <NavMotion>
            <GuestGuard>
                <MinimalLayout />
            </GuestGuard>
        </NavMotion>
    ),
    children: [
        {
            path: '/login',
            element: <AuthLogin />
        },
        { path: '/automation-test', element: <PagesLanding isAutomationTest /> },
        {
            path: '/automation-login',
            element: <AutomationTestLogin />
        },
        {
            path: '/login-callback',
            element: <LoginCongnitoCallback />
        },
        {
            path: '/register',
            element: <AuthRegister />
        },
        {
            path: '/forgot',
            element: <AuthForgotPassword />
        }
    ]
};

export default LoginRoutes;
